export default "__VITE_ASSET__BtBaCyjD__"